import Typography from '@mui/material/Typography';
import { FilterField } from '../../modules/filterSort/filterField';
import { ScrollableStack } from '../../modules/components/scrollableStack';
import MovableListing from '../../modules/listings/movableListing';
import { Paper } from '@mui/material';
import React from 'react';
import { useIntl } from 'react-intl';
import { useFilteredAndSorted } from '../../modules/filterSort/useFilteredAndSorted';
import { useSuspense } from 'rest-hooks';
import { PolicyRuleResource } from '../../model/resources/policyRuleResource';
import { ScoreModelResource } from '../../model/resources/scoreModelResource';
import { DynamicInputBlock } from './modules/dynamicInputBlock';

interface InputBlockProps {
  scoreModel: ScoreModelResource;
}

export const InputBlockHome = (props: InputBlockProps) =>{
  const intl = useIntl();
  const { scoreModel } = props;

  const AvailableRules = () =>{
    const rules = useSuspense(PolicyRuleResource.list());
    const [filteredAndSortedRules, setFilter] = useFilteredAndSorted(
      rules,
      (item) => !scoreModel?.policyRules?.find((rule) => rule.policyRuleId === item.policyRuleId)
    );
  return(
    <Paper sx={{borderColor:'primary'}} elevation={0} style={{height: '100%', margin:'10px'}} >
      <Typography variant={'h3'} sx={{ marginLeft:'10px', marginBottom:'20px'}}>{intl.formatMessage({id: "AvailableRules"})}</Typography>
      <FilterField setFilter={setFilter}  />
      <ScrollableStack spacing={1} style={{height: 'calc(100% - 140px)', overflow:'auto'}} >
      {filteredAndSortedRules.map((rule) => (
        <MovableListing rule={rule} key={rule.policyRuleId} {...rule} />
      ))}
      </ScrollableStack>
    </Paper>
  );
  }
  return(
    <DynamicInputBlock LastComponent={AvailableRules} columnWidth={0.2} />
  )
}